import moment from "moment";
import {
  FETCH_ACCOUNTS,
  FETCH_ACCOUNTS_ERROR,
  FETCH_ACCOUNTS_SUCCESS,
  SET_ACTIVE_TAB,
  REMOVE_VISIT,
  UPDATE_CLAIM_PAYMENT_DATA,
  UPDATE_CLAIM_SERVICE,
  UPDATE_ACCOUNTS_CONFIG,
  REMOVE_INVOICE_ITEM
} from "../../actions/receptionist/accountsAction";

const INIT_STATE = {
  uninvoiced: {
    accounts: [],
    loading: false,
    error: null,
    pagination: {
      totalItems: 0,
      currentPage: 0,
    },
  },
  invoiced: {
    accounts: [],
    loading: false,
    error: null,
    pagination: {
      totalItems: 0,
      currentPage: 0,
    },
  },
  rejected: {
    accounts: [],
    loading: false,
    error: null,
    pagination: {
      totalItems: 0,
      currentPage: 0,
    },
  },
  cancelled: {
    accounts: [],
    loading: false,
    error: null,
    pagination: {
      totalItems: 0,
      currentPage: 0,
    },
  },
  closed: {
    accounts: [],
    loading: false,
    error: null,
    pagination: {
      totalItems: 0,
      currentPage: 0,
    },
  },
  search: {
    accounts: [],
    loading: false,
    error: null,
    pagination: {
      totalItems: 0,
      currentPage: 0,
    },
  },
  config: {
    datePickerType: "range",
    stateDate: moment().subtract(3, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    mipId: null,
    caseType: ["ALL"],
    dateType: "VISIT_DATE",
  },
  activeTab: "uninvoiced",
};

export const accountsReducer = (state = INIT_STATE, action) => {  
  switch (action.type) {
    case FETCH_ACCOUNTS:
      if (
        action.payload.requestPayload &&
        (action.payload.requestPayload.invoiceNo ||
          action.payload.requestPayload.visitNo)
      ) {
        return {
          ...state,
          search: {
            accounts: [],
            loading: true,
            error: null,
            pagination: {
              totalItems: 0,
              currentPage: 0,
            },
          },
        };
      }

      return {
        ...state,
        [action.payload.tab]: {
          accounts: [],
          loading: true,
          error: null,
          pagination: {
            totalItems: 0,
            currentPage: 0,
          },
        },
      };
    case FETCH_ACCOUNTS_SUCCESS:
      if (
        action.payload.requestPayload &&
        (action.payload.requestPayload.invoiceNo ||
          action.payload.requestPayload.visitNo)
      ) {
        return {
          ...state,
          search: {
            accounts: action.payload.data.data,
            loading: false,
            error: null,
            pagination: {
              totalItems: action.payload.data.totalCount,
              currentPage: action.payload.data.page,
            },
            totalClaimedAmount: action.payload.data.totalClaimedAmount,
            totalProcessedAmount: action.payload.data.totalProcessedAmount,
            totalPaidAmount: action.payload.data.totalPaidAmount,
            totalGapAmount: action.payload.data.totalGapAmount,
            totalChargedAmount: action.payload.data.totalChargedAmount,
          },
        };
      }

      return {
        ...state,
        [action.payload.tab]: {
          accounts: action.payload.data.data,
          loading: false,
          error: null,
          pagination: {
            totalItems: action.payload.data.totalCount,
            currentPage: action.payload.data.page,
          },
          totalClaimedAmount: action.payload.data.totalClaimedAmount,
          totalProcessedAmount: action.payload.data.totalProcessedAmount,
          totalPaidAmount: action.payload.data.totalPaidAmount,
          totalGapAmount: action.payload.data.totalGapAmount,
          totalChargedAmount: action.payload.data.totalChargedAmount,
        },
      };
    case FETCH_ACCOUNTS_ERROR:
      if (
        action.payload.requestPayload &&
        (action.payload.requestPayload.invoiceNo ||
          action.payload.requestPayload.visitNo)
      ) {
        return {
          ...state,
          search: {
            ...state["search"],
            loading: false,
            error: action.error,
          },
        };
      }

      return {
        ...state,
        [action.payload.tab]: {
          ...state[action.payload.tab],
          loading: false,
          error: action.error,
        },
      };

    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    case REMOVE_VISIT:
      return {
        ...state,
        [state.activeTab]: {
          ...state[state.activeTab],
          accounts: state[state.activeTab].accounts.filter(
            (account) => account.visitNo !== action.payload
          ),
        },
      };

    case REMOVE_INVOICE_ITEM: {
      const idsToRemove = new Set(action.payload);

      return {
        ...state,
        [state.activeTab]: {
          ...state[state.activeTab],
          accounts: state[state.activeTab].accounts.filter(
            ({ invoiceItemId }) => !idsToRemove.has(invoiceItemId)
          ),
        },
      };
    }

    case UPDATE_CLAIM_PAYMENT_DATA:
      return {
        ...state,
        [state.activeTab]: {
          ...state[state.activeTab],
          accounts: state[state.activeTab].accounts.map((account) =>
            account.claimId === action.payload.claimId
              ? {
                  ...account,
                  claimPaymentStatus: action.payload.claimPaymentStatus,
                  claimStatus: action.payload.claimStatus,
                  paymentRunDate: action.payload.paymentRunDate,
                  paymentRunNumber: action.payload.paymentRunNumber,
                }
              : account
          ),
        },
      };

    case UPDATE_ACCOUNTS_CONFIG:
      return {
        ...state,
        config: {
          ...state.config,
          ...action.payload,
        },
      };

    case UPDATE_CLAIM_SERVICE:
      if (
        Array.isArray(action.payload.service) &&
        action.payload.service.length
      ) {
        let accounts = [];
        action.payload.service.forEach((service) => {
          const account = state[action.payload.tab].accounts.find(
            (account) => account.serviceId === service.id
          );

          if (account !== null) {
            accounts.push({
              ...account,
              processedAmount: service.benefitPaid / 100,
            });
          }
        });
      }

      return {
        ...state,
      };
    default:
      return state;
  }
};
